import "./DotLoader.css"; // include the CSS below

const DotLoader = ({ color = "#1890ff" }) => {
    return (
        <div className="premium-dot-loader">
            <div className="dot" style={{ backgroundColor: color }}></div>
            <div className="dot" style={{ backgroundColor: color }}></div>
            <div className="dot" style={{ backgroundColor: color }}></div>
        </div>
    );
};

export default DotLoader;